import { getStepReferencedStepIDs } from '@sb/remote-control/util/getStepReferencedStepIDs';

import { type Diagnostic, type ValidationRule } from '../../types';

/**
 * Rule: a non-suppressed step that references the output of a suppressed
 * step is a blocking error — the referenced variable will never be produced.
 *
 * Runs only on non-suppressed subjects (`ruleRunner` skips effectively-
 * suppressed steps).
 */
const variableReferencesSuppressedStep: ValidationRule = {
  id: 'variable.referencesSuppressedStep',
  appliesTo: 'step',
  run({ routine, stepId }) {
    if (!stepId) return [];

    const config = routine.stepConfigurations[stepId];
    if (!config) return [];

    const refs = getStepReferencedStepIDs(config);
    if (refs.size === 0) return [];

    const diagnostics: Diagnostic[] = [];

    for (const refID of refs) {
      const target = routine.derived?.stepById[refID];

      if (target?.effectivelySuppressed) {
        diagnostics.push({
          code: 'variable.referencesSuppressedStep',
          message: 'This step references the output of a suppressed step.',
          severity: 'error',
          stepId,
          sourceRule: 'variable.referencesSuppressedStep',
        });

        // One diagnostic per step is enough — don't spam for multiple refs
        break;
      }
    }

    return diagnostics;
  },
};

export const VariableReferencesSuppressedStepValidation =
  variableReferencesSuppressedStep;
